import React, { PureComponent } from "react";
import classNames from "classnames";

import Button from "components/Button";
import SVG from "components/base/SVG";
import { ButtonLink } from "components/base/Button"

import css from "./style.scss";
import PDF from "../../../../assets/images/pdf.svg"; xclose
import { ReactSVG } from "react-svg";
import ButtonUpload from "../../../../components/base/Button/ButtonUpload";
import xclose from "../../../../assets/images/xclose.svg";

class CommonNotes extends PureComponent {
    editorRef = React.createRef();
    isUserTyping = false;
    exec = (command, value = null) => {
        this.editorRef.current.focus();
        document.execCommand(command, false, value);
    };

    handleInput = () => {
        this.isUserTyping = true;
        this.props.onChange?.(this.editorRef.current.innerHTML);
    };

    componentDidMount() {
        if (this.editorRef.current && this.props.value) {
            this.editorRef.current.innerHTML = this.props.value;
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.value !== this.props.value &&
            !this.isUserTyping
        ) {
            this.editorRef.current.innerHTML = this.props.value || "";
        }
        this.isUserTyping = false;
    }

    renderAttachments() {
        const { attachments = [], onRemoveAttachment, onDownloadAttachment, moreFilesLink, onMoreFilesClick, attachmentsDisabled = false } = this.props;
        if (!attachments.length) return null;
        const visible = attachments.slice(-3);
        const extra = attachments.length - visible.length;

        return (
            <div className={css.attachments}>
                {[...visible].reverse().map((file, i) => (
                    <div
                        key={`${file.name}-${file.file?.lastModified || i}`}
                        className={css.attachmentChip}

                        onClick={attachmentsDisabled ? undefined : () => onDownloadAttachment(file)}
                    >
                        <ReactSVG src={PDF} />
                        <span>{file.name}</span>

                        <button
                            type="button"
                            className={css.removeFile}
                            onClick={(e) => {
                                e.stopPropagation();
                                onRemoveAttachment(attachments.length - 1 - i);
                            }}
                        >
                            <ReactSVG src={xclose} />
                        </button>

                    </div>
                ))}

                {extra > 0 && (
                    attachmentsDisabled
                        ? <span className={classNames(css.moreFiles, css.disabledMoreFiles)}>+ {extra} more</span>
                        : <ButtonLink to={moreFilesLink} className={css.moreFiles} onClick={(e) => {
                            if (this.props.onMoreFilesClick) {
                                e.preventDefault();
                                this.props.onMoreFilesClick();
                            }
                        }}>+ {extra} more</ButtonLink>
                )}
            </div>
        );

    }


    render() {
        const {
            title = "Notes",
            lastUpdated,
            value,
            placeholder = "Type something...",
            className,
            onSave,
            onUpload,
            notesDirty,
            // ATAI-372: the Investor Profile card already labels this section
            // via its own layout, so the generic "Notes" title this
            // component normally shows is redundant there -- but "Last
            // Updated" is still worth keeping when there's one to show.
            // Other callers (Dialer campaigns) are unaffected by the default.
            hideTitle = false,
        } = this.props;

        return (
            <div className={classNames(css.notesWrapper, className)}>
                {!hideTitle || lastUpdated ? (
                    <div className={css.header}>
                        {hideTitle ? null : <span className={css.title}>{title}</span>}
                        {lastUpdated && (
                            <span className={css.updated}>
                                Last Updated: {lastUpdated}
                            </span>
                        )}
                    </div>
                ) : null}

                <div className={css.card}>
                    <div className={css.toolbar}>
                        <div className={css.tools}>
                            <div className={css.toolGroup}>
                                <button
                                    className={classNames(css.toolBtn, css.textTool)}
                                    onClick={() => this.exec("bold")}
                                >
                                    <SVG icon="iconBold" size={15} />
                                </button>

                                <button
                                    className={classNames(css.toolBtn, css.textTool)}
                                    onClick={() => this.exec("italic")}
                                >
                                    <SVG icon="iconItalic" size={15} />
                                </button>

                                <button
                                    className={classNames(css.toolBtn, css.textTool)}
                                    onClick={() => this.exec("underline")}
                                >
                                    <SVG icon="iconUnderline" size={15} />
                                </button>
                            </div>

                            <div className={css.toolGroup}>
                                <button
                                    className={classNames(css.toolBtn, css.listTool)}
                                    onClick={() => this.exec("insertUnorderedList")}
                                >
                                    <SVG icon="iconBulletList" size={15} />
                                </button>

                                <button
                                    className={classNames(css.toolBtn, css.listTool)}
                                    onClick={() => this.exec("insertOrderedList")}
                                >
                                    <SVG icon="iconNumberedList" size={15} />
                                </button>
                            </div>
                        </div>

                        <ButtonUpload
                            className={css.upload}
                            accept="*"
                            onChange={onUpload}
                            document={false}
                        >
                            <span className={css.uploadContent}>
                                <SVG icon="iconUploadFile" size={17} />
                                <span>Upload File</span>
                            </span>
                        </ButtonUpload>

                    </div>

                    <div className={css.editor}>
                        <div
                            ref={this.editorRef}
                            className={css.richEditor}
                            contentEditable
                            dir="ltr"
                            suppressContentEditableWarning
                            onInput={this.handleInput}
                            data-placeholder={placeholder}
                        />
                    </div>
                    <div className={css.attachmentsFooter}>
                        {this.renderAttachments()}

                        <Button className={css.saveBtn} onClick={onSave} disabled={!notesDirty}>
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default CommonNotes;
